// Extract plain text from HTML
export default function plainText(html) {
    if (!html) return ''

    // Create a temporary div element to parse the HTML
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = html

    // Function to recursively extract text
    function extractText(node) {
        let text = ''
        for (const childNode of node.childNodes) {
            if (childNode.nodeType === Node.TEXT_NODE) {
                text += childNode.textContent
            } else if (childNode.nodeType === Node.ELEMENT_NODE) {
                const tagName = childNode.tagName.toLowerCase()
                // Skip script, style, table, and img tags
                if (
                    tagName !== 'script' &&
                    tagName !== 'style' &&
                    tagName !== 'table' &&
                    tagName !== 'img'
                ) {
                    text += extractText(childNode)
                }
            }
        }
        return text
    }

    // Call extractText function, skipping script, style, table, and img tags
    const plainText = extractText(tempDiv)

    // Remove the temporary div element
    tempDiv.remove()

    return plainText
}
